/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'company-hub.carousel-extension.card-strip.card.label': 'スライド {positionInSet}/{setSize}',
  'company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title': 'タイトルを追加',
  'company-hub.carousel-extension.carousel-navigation.pause': '一時停止',
  'company-hub.carousel-extension.carousel-navigation.play': '再生',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.next': '次へ',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.previous': '戻る',
  'company-hub.carousel-extension.config-panel.add-frame-cta': 'フレームを追加',
  'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list': 'フレームを追加してください',
  'company-hub.carousel-extension.config-panel.layout.title': 'レイアウトを選択',
  'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label': '画像の上のフレーム付きテキスト',
  'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label': '無地の背景',
  'company-hub.carousel-extension.config-panel.layouts.split-design-content.label': 'スプリット デザイン',
  'company-hub.carousel-extension.config-panel.link.field.label': 'リンク',
  'company-hub.carousel-extension.config-panel.lozenge.label.updated': '更新済み',
  'company-hub.carousel-extension.config-panel.navigation.progress-circles': '進捗を表す円',
  'company-hub.carousel-extension.config-panel.navigation.thumbnails': 'サムネイル',
  'company-hub.carousel-extension.config-panel.preamble-link.label-v2': 'カルーセルの詳細',
  'company-hub.carousel-extension.config-panel.preamble-v2':
    '最大 {number} 個の回転座標系のセットを設計します。{supportLink}',
  'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link':
    '最大 {number} 個の回転座標系のセットを設計します。',
  'company-hub.carousel-extension.config-panel.style.general.title': '全般',
  'company-hub.carousel-extension.config-panel.style.navigation.title': 'ナビゲーション',
  'company-hub.carousel-extension.config-panel.styles.autoplay-label': '自動再生',
  'company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content':
    '表示モードで {number} 秒ごとに自動スクロールするようにカルーセルを設定してください',
  'company-hub.carousel-extension.config-panel.tab.content.label': 'コンテンツ',
  'company-hub.carousel-extension.config-panel.tab.styles.label': 'スタイル',
  'company-hub.carousel-extension.config-panel.title': 'カルーセル',
  'company-hub.carousel-extension.description.field.label': '説明',
  'company-hub.carousel-extension.description.placeholder':
    'このフレームをカスタマイズして、ローテーションするカルーセルを作成しましょう。',
  'company-hub.carousel-extension.frame-spotlight.label': '{setSize} のフレーム {positionInSet}',
  'company-hub.carousel-extension.frame.background.color': '背景色',
  'company-hub.carousel-extension.frame.color-contrast.fail':
    '選択したテキストと背景の色は読みやすさの基準を満たしていません。',
  'company-hub.carousel-extension.frame.color-contrast.success':
    '選択したテキストと背景の色は読みやすさの基準を満たしています。',
  'company-hub.carousel-extension.frame.text.color': 'テキストの色',
  'company-hub.carousel-extension.hub-element.description': '美しいフレームが回転するセット',
  'company-hub.carousel-extension.hub-element.title': 'カルーセル',
  'company-hub.carousel-extension.manifest.macro-description': '動的フレームの回転トリオを作成します。',
  'company-hub.carousel-extension.manifest.macro-title': 'カルーセル',
  'company-hub.carousel-extension.manifest.macro-title.updated': 'カルーセル [最新版]',
  'company-hub.carousel-extension.placeholder.description':
    'このフレームをカスタマイズして、ローテーションするカルーセルを作成しましょう。',
  'company-hub.carousel-extension.placeholder.title': 'フレームにタイトルを付ける',
  'company-hub.carousel-extension.recommended.field.label': '(推奨)',
  'company-hub.carousel-extension.title.field.label': 'タイトル',
  'company-hub.carousel-extension.title.placeholder': 'フレームにタイトルを付ける',
};
